<template>
  <div class="mt28">
    <table class="tbl-type tbl-type-row">
      <caption></caption>
      <colgroup>
        <col style="width:9%" />
        <col style="width:auto" />
      </colgroup>
      <tbody>
        <tr>
          <th class="center">계좌정보</th>
          <td class="left">
            <div v-if="status === 'READY'">
              <!-- 상태값 : READY(시작), NOTAPPROVED(미승인), APPROVED(승인), REJECTED(승인거절/서류보완) -->
              <div class="form-box">
                <div class="form-group" :class="{'error': isError}">
                  <HconInput type="account" ref="inputAccountRef" v-model:account-value="accountForm" label="계좌정보" :hide-label="true" inputClass="md" selectBoxTitleClass="md wd186" :showButton="true" buttonClass="btn-gray md" buttonText="계좌인증" @accountBtnClick="handleVerify" />
                  <HconComPCUpload v-if="showFileFlag"
                    :token-provider="`/api/v1/common/create-upload-token/acct/2048/1`"
                    :uploaded="bzcoRgcrt"
                    @change="onChangeBzcoRgcrt"         
                    label="" 
                    :hide-label="false" 
                    inputClass="md" 
                    buttonClass="btn-outline md" 
                    :showButton="true" 
                    buttonText="파일찾기"
                    :chkAcceptType="['png','jpg', 'pdf']"
                    :placeholder="filePlaceholder"
                />
                </div>
                <p v-if="isNoFileError && isNoFileErrorType == 'null'" class="helper-text error p0">통장 사본을 업로드해주세요.</p>
                <p v-if="isNoFileExtError && isNoFileExtErrorType == 'null'" class="helper-text error p0">파일은 png, jpg, pdf 형식의 2MB 이하로 등록해주세요.</p>
              </div>
              <ul class="dot-list mt20" v-if="showFileFlag">
                <li>통장사본 파일은 png, jpg, pdf 형식의 2MB 이하로 등록하시기 바랍니다.</li>
              </ul>
            </div>
            <div v-else class="flex">
              <div class="fs16">
                <p>{{ accountForm.bank }} {{ HconCommonUtils.format.account(accountForm.accountNumber) }}<br />{{ accountForm.depositor }}</p>
                <!-- <p class="mt10">{{ accountForm.ownerName }}</p> -->
              </div>
              <button v-if="status === 'APPROVED' || status === 'REJECTED'" type="button" class="btn btn-gray md wd98 left-auto" @click="handleReadyChange">계좌변경</button>
            </div>
          </td>
        </tr>
        <tr>
          <th class="center">계좌상태</th>
          <td class="left">
            <span v-if="status === 'READY' || status === 'NOTAPPROVED'" class="status-text unapproved">미승인</span>
            <span v-if="status === 'APPROVED'" class="status-text success">승인</span>
            <span v-if="status === 'REJECTED'" class="status-text error">승인 거절 : {{ accountForm.apvRjctRsnCntn }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <HconLoading v-model="isLoadingShow" />
</template>
<script setup lang="ts">
import HconInput from '@/components/com/HconComPCInputField.vue'
import { usePopup } from '@/composables/hconUsePopup'
import { ref , onMounted } from 'vue';
import HconComPCUpload from '@/components/com/HconComPCUpload.vue'
import { COMMON_CODE, MEMBER_CODE } from '@/constants/hconMessageConstants'
import HconLoading from '@/components/com/HconComPCLoading.vue';

const fetchBuilder  = useHconFetchBuilder(); 
//init 함수
onMounted(async () => {
  //setAccountStatus();
})


// 입력창 오류일 경우
const isError = ref(false)
const showErrorMsg = ref(false)
const showFileFlag = ref(true)
const inputAccountRef  = ref<InstanceType<typeof HconInput> | null>(null)
// 계좌 상태 값 : READY(시작), NOTAPPROVED(미승인), APPROVED(승인), REJECTED(승인거절/서류보완)
const status = ref('READY') 

const isNoFileError = ref(false)
const isNoFileErrorType = ref("")
const isNoFileExtError = ref(false)
const isNoFileExtErrorType = ref("")
const isLoadingShow = ref(false)

//const bankList = ['신한은행', '국민은행', '우리은행', '하나은행', '농협은행']
const accountForm = ref({
  bank: '',
  bankCode : '', 
  accountNumber: '',
  depositor: '',
  identifyNo: '',
  crtfYn : 'N',
  filePath: '',
  fileName: '',
  acntCrtfYn: '',
  acntCrtfDt : '',
  acntApvYn: '',
  acntApvDt: '',
  apvRjctRsnCntn: '',
  hcApvStCd: ''
})

watch(accountForm, (newV, ) => {
  emit("update:account-value", accountForm.value)
}, {deep : true})

// 계좌변경 버튼 선택시 수정 모드로 변경
const handleReadyChange = () => {
  status.value = 'READY'
  emit("update:status", status.value)
}

// 팝업
const {
  showAlert
} = usePopup()


const props = defineProps({
  accountValue: {
    type: Object,
    default: () => ({})
  },
  fileValue: {
    type: Object,
    // default: ''
  },
  divCd: {
    type: String,
    // default: ''
  },
})
onMounted(async () => {
  fetchBuilder
    .get<AjaxResult<any>>("/api/v1/mypage/account/get-information/" + props.divCd)
    .query()
    .build()
    .execute()
    .then((result) => {
      if(result){
        accountForm.value.bank = result.data?.hcFnnsCdNm
        accountForm.value.bankCode = result.data?.hcFnnsCd
        accountForm.value.accountNumber = result.data?.hcEncActno
        accountForm.value.depositor = result.data?.dpsrNm
        accountForm.value.acntCrtfYn = result.data?.acntCrtfYn
        accountForm.value.acntCrtfDt = result.data?.acntCrtfDt
        accountForm.value.acntApvYn = result.data?.acntApvYn
        accountForm.value.acntApvDt = result.data?.acntApvDt
        accountForm.value.apvRjctRsnCntn = result.data?.apvRjctRsnCntn
        accountForm.value.hcApvStCd = result.data?.hcApvStCd
      }
      emit("update:account-value", accountForm)
      setAccountStatus(accountForm);
    });

  if(props.accountValue) {
    accountForm.value = {
      ...accountForm.value,
      ...props.accountValue
    }
  }
})

const bzcoRgcrt = ref<CommonFile[]>([]);
const emit = defineEmits(['accountCheckResult', 'update:account-value', 'update:file-value', 'update:status']);

// 계좌 인증시 승인, 미승인, 승인 거절 로직
const rejectedMsg = ref('')
const handleVerify = async () => {
  if(!inputAccountRef.value?.onAccountValidate(true)) 
  {
    return false;
  }

  if(isLoadingShow.value) return;

  try {
    isLoadingShow.value = true;
    await fetchBuilder
      .post<AjaxResult<any>>("/api/v1/certificate/request-account-certificate")
      .body(
        {
          userName : accountForm.value.depositor,
          userAcctNo: accountForm.value.accountNumber,
          bankCd : accountForm.value.bankCode,
          identifyNo: accountForm.value.identifyNo
        }
      )
      .build()
      .execute()
      .then((result) => {
        if(result.data.resultCode == '0000' || result.data.resultCode == '0001' || result.data.resultCode == '0002') {

          showAlert({
            message :  HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "계좌인증이"),
          })

          emit('accountCheckResult', true);
        } else {
          showAlert({
            message :  result.data.resultMsg,
          })
        }
      });
  } catch (err) {
    showAlert({
      message :  HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9041),
    })
  } finally {
    // 작업중 해제
    isLoadingShow.value = false;
  }
  
  // if(!inputAccountRef.value?.onAccountValidate(true)){
  //   return false;
  // } else {
  // //계좌인증 인터페이스 호출
  // showAccountResult()
  // }

}

const onFileValidate = () => {
  if(cu.isEmpty(bzcoRgcrt)) {
    isNoFileError.value = true
    isNoFileErrorType.value = 'null'
    console.log("FAIL")
    return false;
  }

  isNoFileError.value = false
  isNoFileErrorType.value = ''

  return true;
}

const showAccountResult = () => {
  // 가상 연동 체크
  const isConnectSuccess = !accountForm.value.accountNumber.includes('00')

  if (!isConnectSuccess) {
    showAlert({
      title: '계좌 인증 실패',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9041),
      confirmText: '확인'
    }) 
  } else {
    showAlert({
      title: '계좌 인증 완료',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, '계좌인증이'),
      confirmText: '확인'
    }) 
  }
}

const setAccountStatus = (accountForm : any) => {
  const acntCrtfYn = accountForm.value.acntCrtfYn??''
  const acntCrtfDt = accountForm.value.acntCrtfDt??''
  const acntApvYn = accountForm.value.acntApvYn??''
  const acntApvDt = accountForm.value.acntApvDt??''

  // 최종상태
  if (acntCrtfYn == "Y" && acntCrtfDt != '' && acntApvYn == "Y" && acntApvDt != '') {
    status.value = 'APPROVED'
    //emit("update:accountValue", accountForm)
  } else if (accountForm.value.hcApvStCd == '1003') {
    status.value = 'REJECTED'
  } else if (acntCrtfYn == "Y" && acntCrtfDt != '' && acntApvYn == 'N' && acntApvDt == '') {
    status.value = 'NOTAPPROVED'
  } else {
    status.value = 'READY'
  }
  
  emit("update:status", status.value)
}
const inputBzcoRgcrt  = ref("")
const filePlaceholder = ref("통장사본 파일은 png, jpg, pdf 형식의 2MB 이하로 등록하시기 바랍니다.")

const onChangeBzcoRgcrt = (uploadedFiles: CommonFile[]) => {
  bzcoRgcrt.value = uploadedFiles;
  console.log(JSON.stringify(uploadedFiles, null, 2))
  // status 값 체크
  const chkStatus = uploadedFiles.filter(file => file.status === 'STORED') // 실제
  // const chkStatus = uploadedFiles.filter(file => file.status === 'STORED' || file.status === 'ERROR') // 테스트 코드 
  if(uploadedFiles[0]) {
    filePlaceholder.value = uploadedFiles[0].name;
    inputBzcoRgcrt.value = uploadedFiles[0].name;
  }
  
  emit('update:file-value', bzcoRgcrt.value);
  // temp 정상인 경우 Upload
  // if(chkStatus.length > 0) {
  //   uploadBzcoRgcrt();
  // }
}

defineExpose({
  onFileValidate,
  setAccountStatus
})

</script>
<style lang="scss">
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>